/**
 * Names of all script functions.
 *
 * @module
 */

/** Script function type for `0x1::code::publish_package_txn`. */
export const publish_package_txn = "0x1::code::publish_package_txn" as const;
